/**
 * TanStack Query hooks for `abnormal-pattern-ml`. Read-only report — list only.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	list,
	abnormalPatternMlQueryKeys,
	type ListAbnormalPatternMlResponse,
} from "./api";

export function useAbnormalPatternMlList(): UseQueryResult<ListAbnormalPatternMlResponse, Error> {
	return useQuery({
		queryKey: abnormalPatternMlQueryKeys.list(),
		queryFn: list,
	});
}
